<template>
  <v-navigation-drawer
    v-model="drawerControl"
    absolute
    temporary
    right
    :width="this.$vuetify.breakpoint.xsOnly ? 376 : 480"
    color="primary lighten-1"
    dark
    touchless
    style="z-index: 999;"
  >
    <div class="d-flex justify-start">
      <v-btn
        color="primary darken-1"
        @click.stop="drawerControl = false"
        icon
        class="side-menu-close-button"
      >
        <v-icon color="white">close</v-icon>
      </v-btn>
    </div>
    <v-list
      nav
      dense
      flat
    >
      <v-list-item-group
        v-model="group"
        active-class="list-item--active"
      >
        <side-menu-item
          v-for="item of items"
          :key="item.pageId || item.pageName"
          :page="item"
        />
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex'
import { preconfiguredPageRoutes } from '@/config'


export default {
  data () {
    return {
      group: null,
    }
  },
  computed: {
    ...mapState(['pages', 'state']),
    items () {
      if (!this.pages.dashboardItems.length) {
        return null
      }
      const items = this.pages.dashboardItems
      const itemsEnabled = items.filter((item) => item.enabled === true)

      return itemsEnabled
        .sort((a, b) => (a.order === b.order ? 0 : a.order > b.order ? 1 : -1))
    },
    drawerControl: {
      get () {
        return this.state.showSideMenu
      },
      set (value) {
        this.$store.commit('state/setShowSideMenu', value)
      },
    },
  },
  watch: {
    $route (to, from) {
      if (to.name === 'main') {
        this.group = null
      }
      if (!this.items) return
      if (to.name === 'page_details') {
        const pageId = to.params.pageId
        const index = this.items.findIndex((item) => item.pageId === pageId)
        if (index >= 0) this.group = index
      }
      else {
        const preconfiguredPageUrl = to.name
        const index = this.items.findIndex((item) => preconfiguredPageRoutes[item.pageName] === preconfiguredPageUrl)
        if (index >= 0) this.group = index
      }
    },
  },
  components: {
    SideMenuItem: () => import('@/components/view-components/SideMenuItem.vue'),
  },
}
</script>
<style scoped>
  .list-item--active {
    background-color: rgba(var(--v-primary-darken1-rgb), 0.2);
  }

  .side-menu-close-button {
    border-radius: 0 0 8px 0 !important;
    background-color: rgba(var(--v-primary-darken1-rgb), 0.3);
    width: 45px;
    height: 45px;
  }
</style>